import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { environment } from 'src/environments/environment';
import { retry , catchError } from 'rxjs/operators';

const getEvaluacion = 'seicep/';
const getResultados = 'seicep/resultados/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
  
}; 

@Injectable({
  providedIn: 'root',
})
export class SeicepService {
 

  
  constructor(private http:HttpClient) { }


  getEvaluacion(idJardinPeriodo : number): Observable<any> {
    return this.http.get(environment.apiEndpoint + getEvaluacion + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  getResultados(idJardinPeriodo: number): Observable<any> {
    return this.http.get(environment.apiEndpoint + getResultados + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  handleError(error: any) {
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
